'use client';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import {
  getEventIdCopy,
  getRequestIdCopy,
  getSupportCodeCopy,
} from '@/lib/copy/user-facing-messages';

interface ErrorSupportDetailsProps {
  eventId?: string | null;
  requestId?: string | null;
  supportCode?: string | null;
  onReport?: () => void;
  reportAction?: string;
  className?: string;
}

export function ErrorSupportDetails({
  eventId,
  requestId,
  supportCode,
  onReport,
  reportAction = 'Report issue',
  className,
}: ErrorSupportDetailsProps) {
  const references = [
    getSupportCodeCopy(supportCode),
    getRequestIdCopy(requestId),
    getEventIdCopy(eventId),
  ].filter(Boolean) as string[];

  if (references.length === 0 && !onReport) {
    return null;
  }

  return (
    <div
      className={cn(
        'border-border/60 bg-muted/30 mt-4 w-full max-w-full min-w-0 overflow-hidden rounded-lg border p-3 text-left',
        className
      )}
    >
      {references.length > 0 ? (
        <div className="text-muted-foreground min-w-0 space-y-1 text-xs">
          {references.map(reference => (
            <p key={reference} className="break-words">
              {reference}
            </p>
          ))}
        </div>
      ) : null}

      {onReport ? (
        <Button
          type="button"
          variant="outline"
          size="sm"
          className={cn(references.length > 0 ? 'mt-3' : undefined)}
          onClick={onReport}
        >
          {reportAction}
        </Button>
      ) : null}
    </div>
  );
}
